function overlayAspectRatio() {

    $('.pattern-overlay').each(function() {
        $this = $(this);

        // Get height of overlay
        var overlayHeight = $this.outerHeight();

        // Dynamically add width
        $this.width(overlayHeight);

    });

};

$(window).on('resize load',function(){
    overlayAspectRatio();
});